// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as CommonCardProps$OrcaPaymentPage from "../Hooks/CommonCardProps.bs.js";
import * as SadPortRegistry$OrcaPaymentPage from "./SadPortRegistry.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "../Components/PaymentInputField.bs.js";
import * as CardCollectorBridge$OrcaPaymentPage from "./CardCollectorBridge.bs.js";
import * as CardFormCoordinator$OrcaPaymentPage from "./CardFormCoordinator.bs.js";
import * as CardFormPortProtocol$OrcaPaymentPage from "./CardFormPortProtocol.bs.js";
import * as SubscriptionEventHooks$OrcaPaymentPage from "../Hooks/SubscriptionEventHooks.bs.js";

function useCardFieldBase(logger, paymentType, cardBrandOverrideOpt, dualPlaneOpt, param) {
  let cardBrandOverride = cardBrandOverrideOpt !== undefined ? cardBrandOverrideOpt : "";
  let dualPlane = dualPlaneOpt !== undefined ? dualPlaneOpt : false;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let setShowPaymentMethodsScreen = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  React.useEffect(() => {
    setShowPaymentMethodsScreen(param => true);
  }, []);
  let groupIdFromUrl = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(RescriptReactRouter.useUrl(undefined, undefined).search, "groupId");
  let elementNameForPortKey;
  switch (paymentType) {
    case "CardNumberElement" :
      elementNameForPortKey = "cardNumber";
      break;
    case "CardExpiryElement" :
      elementNameForPortKey = "cardExpiry";
      break;
    case "CardCVCElement" :
      elementNameForPortKey = "cardCvc";
      break;
    default:
      elementNameForPortKey = "";
  }
  let portKey = dualPlane && groupIdFromUrl !== "" && elementNameForPortKey !== "" ? CardFormCoordinator$OrcaPaymentPage.portKey(groupIdFromUrl, elementNameForPortKey) : "";
  let hasPortPlane = portKey !== "";
  let match$1 = React.useState(() => 0);
  let setRegistryVersion = match$1[1];
  React.useEffect(() => {
    let onRegistryChange = () => setRegistryVersion(v => v + 1 | 0);
    SadPortRegistry$OrcaPaymentPage.addChangeListener(onRegistryChange);
    return () => SadPortRegistry$OrcaPaymentPage.removeChangeListener(onRegistryChange);
  }, []);
  let match$2 = React.useState(() => "");
  let setPortBrandOverride = match$2[1];
  let effectiveCardBrandOverride = cardBrandOverride !== "" ? cardBrandOverride : match$2[0];
  let match$3 = CommonCardProps$OrcaPaymentPage.useCardForm(logger, paymentType, false, false, undefined, effectiveCardBrandOverride);
  let cvcProps = match$3.cvcProps;
  let expiryProps = match$3.expiryProps;
  let cardProps = match$3.cardProps;
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = keys.parentURL;
  React.useEffect(() => {
    if (keys.iframeId !== "" && keys.iframeId !== "no-element") {
      let elementType;
      switch (paymentType) {
        case "CardNumberElement" :
          elementType = "cardNumber";
          break;
        case "CardExpiryElement" :
          elementType = "cardExpiry";
          break;
        case "CardCVCElement" :
          elementType = "cardCvc";
          break;
        default:
          elementType = "card";
      }
      SubscriptionEventHooks$OrcaPaymentPage.emitReady(keys.iframeId, elementType);
    }
  }, [keys.iframeId]);
  let focusTarget;
  switch (paymentType) {
    case "CardExpiryElement" :
      focusTarget = expiryProps.expiryRef;
      break;
    case "CardCVCElement" :
      focusTarget = cvcProps.cvcRef;
      break;
    default:
      focusTarget = cardProps.cardRef;
  }
  React.useEffect(() => {
    let handleFocusEvent = ev => {
      if (ev.source !== window.parent || parentURL !== "*" && ev.origin !== parentURL) {
        return;
      }
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (Core__Option.isSome(dict["doFocus"])) {
        return CardUtils$OrcaPaymentPage.focusRef(focusTarget);
      } else if (Core__Option.isSome(dict["doBlur"])) {
        return CardUtils$OrcaPaymentPage.blurRef(focusTarget);
      } else {
        return;
      }
    };
    return Utils$OrcaPaymentPage.handleMessage(handleFocusEvent, "");
  }, [
    focusTarget,
    parentURL
  ]);
  let clearFieldValue = () => {
    switch (paymentType) {
      case "CardExpiryElement" :
        expiryProps.setCardExpiry(param => "");
        return expiryProps.setIsExpiryValid(param => {});
      case "CardCVCElement" :
        cvcProps.setCvcNumber(param => "");
        return cvcProps.setIsCVCValid(param => {});
      default:
        return;
    }
  };
  React.useEffect(() => {
    if (portKey !== "") {
      let port = SadPortRegistry$OrcaPaymentPage.getPort(portKey);
      if (port !== undefined) {
        Primitive_option.valFromOption(port).onmessage = ev => {
          let frameJson = ev.data;
          let match = CardFormPortProtocol$OrcaPaymentPage.decodePortFrame(frameJson);
          if (match !== undefined) {
            let payload = match.payload;
            let kind = match.kind;
            if (kind === CardFormPortProtocol$OrcaPaymentPage.kindDoFocus && Core__Option.getOr(Core__JSON.Decode.bool(payload), false)) {
              return CardUtils$OrcaPaymentPage.focusRef(focusTarget);
            } else if (kind === CardFormPortProtocol$OrcaPaymentPage.kindDetectedCardBrand) {
              return setPortBrandOverride(param => Core__Option.getOr(Core__JSON.Decode.string(payload), ""));
            } else if (kind === CardFormPortProtocol$OrcaPaymentPage.kindClearField) {
              return clearFieldValue();
            } else {
              console.warn(`[CommonCardFieldHooks] dropped port frame on unknown kind "` + kind + `" (portKey "` + portKey + `")`);
              return;
            }
          }
          console.warn(`[CommonCardFieldHooks] dropped un-decodable port frame (portKey "` + portKey + `")`);
        };
      }
    }
  }, [
    portKey,
    match$1[0],
    focusTarget
  ]);
  let match$4;
  switch (paymentType) {
    case "CardNumberElement" :
      match$4 = [
        Core__Option.getOr(cardProps.isCardValid, false),
        cardProps.cardNumber === ""
      ];
      break;
    case "CardExpiryElement" :
      match$4 = [
        Core__Option.getOr(expiryProps.isExpiryValid, false),
        expiryProps.cardExpiry === ""
      ];
      break;
    case "CardCVCElement" :
      match$4 = [
        Core__Option.getOr(cvcProps.isCVCValid, false),
        cvcProps.cvcNumber === ""
      ];
      break;
    default:
      match$4 = [
        false,
        true
      ];
  }
  let focusReady;
  switch (paymentType) {
    case "CardNumberElement" :
      focusReady = CardUtils$OrcaPaymentPage.focusCardValid(cardProps.cardNumber, cardProps.cardBrand);
      break;
    case "CardExpiryElement" :
      focusReady = CardValidations$OrcaPaymentPage.clearSpaces(expiryProps.cardExpiry).length === 4 && Primitive_object.equal(expiryProps.isExpiryValid, true);
      break;
    case "CardCVCElement" :
      focusReady = cvcProps.cvcNumber.length === cvcProps.maxCVCLength && Primitive_object.equal(cvcProps.isCVCValid, true);
      break;
    default:
      focusReady = false;
  }
  CardCollectorBridge$OrcaPaymentPage.useEmitCardState(cardProps.cardNumber, expiryProps.cardExpiry, cvcProps.cvcNumber, cardProps.cardBrand, match$4[0], match$4[1], cardProps.isCardValid, expiryProps.isExpiryValid, cvcProps.isCVCValid, hasPortPlane, hasPortPlane, hasPortPlane, focusReady, portKey);
  return {
    localeString: match.localeString,
    cardProps: cardProps,
    expiryProps: expiryProps,
    cvcProps: cvcProps
  };
}

function useCardNumberField(logger, dualPlaneOpt, param) {
  let dualPlane = dualPlaneOpt !== undefined ? dualPlaneOpt : false;
  return useCardFieldBase(logger, "CardNumberElement", undefined, dualPlane, undefined);
}

function useCardExpiryField(logger, dualPlaneOpt, param) {
  let dualPlane = dualPlaneOpt !== undefined ? dualPlaneOpt : false;
  return useCardFieldBase(logger, "CardExpiryElement", undefined, dualPlane, undefined);
}

function useCardCvcField(logger, cardBrandOverrideOpt, dualPlaneOpt, param) {
  let cardBrandOverride = cardBrandOverrideOpt !== undefined ? cardBrandOverrideOpt : "";
  let dualPlane = dualPlaneOpt !== undefined ? dualPlaneOpt : false;
  return useCardFieldBase(logger, "CardCVCElement", cardBrandOverride, dualPlane, undefined);
}

function CommonCardFieldHooks$RenderCardNumber(props) {
  let state = props.state;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let numberPlaceholder = Core__Option.getOr(Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardNumberPlaceholder), "1234 1234 1234 1234");
  let match$1 = state.cardProps;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(PaymentInputField$OrcaPaymentPage.make, {
      isValid: Primitive_option.some(match$1.isCardValid),
      setIsValid: match$1.setIsCardValid,
      height: themeObj.inputFieldHeight,
      value: match$1.cardNumber,
      onChange: match$1.changeCardNumber,
      onBlur: match$1.handleCardBlur,
      rightIcon: match$1.icon,
      errorString: match$1.cardError,
      fieldName: state.localeString.cardNumberLabel,
      isLabelHidden: true,
      isErrorHidden: true,
      id: "card-number",
      type_: "tel",
      maxLength: match$1.maxCardLength,
      placeholder: numberPlaceholder,
      className: "tracking-widest w-full",
      inputRef: match$1.cardRef,
      paymentType: "CardNumberElement",
      autocomplete: "cc-number"
    }),
    className: "animate-slowShow flex flex-col",
    style: {
      height: themeObj.inputFieldHeight,
      gridGap: "0px"
    }
  });
}

let RenderCardNumber = {
  make: CommonCardFieldHooks$RenderCardNumber
};

function CommonCardFieldHooks$RenderCardExpiry(props) {
  let state = props.state;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let expiryPlaceholder = Core__Option.getOr(Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardExpiryPlaceholder), state.localeString.expiryPlaceholder);
  let match$1 = state.expiryProps;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(PaymentInputField$OrcaPaymentPage.make, {
      isValid: Primitive_option.some(match$1.isExpiryValid),
      setIsValid: match$1.setIsExpiryValid,
      height: themeObj.inputFieldHeight,
      value: match$1.cardExpiry,
      onChange: match$1.changeCardExpiry,
      onBlur: match$1.handleExpiryBlur,
      errorString: match$1.expiryError,
      fieldName: state.localeString.validThruText,
      isLabelHidden: true,
      isErrorHidden: true,
      id: "card-expiry",
      type_: "tel",
      maxLength: 7,
      placeholder: expiryPlaceholder,
      className: "tracking-widest w-full",
      inputRef: match$1.expiryRef,
      paymentType: "CardExpiryElement",
      autocomplete: "cc-exp"
    }),
    className: "animate-slowShow flex flex-col",
    style: {
      height: themeObj.inputFieldHeight,
      gridGap: "0px"
    }
  });
}

let RenderCardExpiry = {
  make: CommonCardFieldHooks$RenderCardExpiry
};

function CommonCardFieldHooks$RenderCardCvc(props) {
  let state = props.state;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let cvcPlaceholder = Core__Option.getOr(Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardCvcPlaceholder), "123");
  let match$2 = state.cvcProps;
  let cvcNumber = match$2.cvcNumber;
  let isCVCValid = match$2.isCVCValid;
  let isCvcValidValue = CardUtils$OrcaPaymentPage.getBoolOptionVal(isCVCValid);
  let match$3 = CardUtils$OrcaPaymentPage.useCardDetails(cvcNumber, isCvcValidValue, isCVCValid);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(PaymentInputField$OrcaPaymentPage.make, {
      isValid: Primitive_option.some(isCVCValid),
      setIsValid: match$2.setIsCVCValid,
      height: themeObj.inputFieldHeight,
      value: cvcNumber,
      onChange: match$2.changeCVCNumber,
      onBlur: match$2.handleCVCBlur,
      rightIcon: CardUtils$OrcaPaymentPage.setRightIconForCvc(match$3[0], match$3[2], themeObj.colorIconCardCvcError, match$3[1], Core__Option.getOr(Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cvcIconOverride), CardUtils$OrcaPaymentPage.getLayoutClass(match$1.layout).cvcIcon)),
      errorString: match$2.cvcError,
      fieldName: state.localeString.cvcTextLabel,
      isLabelHidden: true,
      isErrorHidden: true,
      id: "card-cvc",
      type_: "tel",
      maxLength: match$2.maxCVCLength,
      placeholder: cvcPlaceholder,
      className: "tracking-widest w-full",
      inputRef: match$2.cvcRef,
      paymentType: "CardCVCElement",
      autocomplete: "cc-csc"
    }),
    className: "animate-slowShow flex flex-col",
    style: {
      height: themeObj.inputFieldHeight,
      gridGap: "0px"
    }
  });
}

let RenderCardCvc = {
  make: CommonCardFieldHooks$RenderCardCvc
};

export {
  useCardFieldBase,
  useCardNumberField,
  useCardExpiryField,
  useCardCvcField,
  RenderCardNumber,
  RenderCardExpiry,
  RenderCardCvc,
}
/* jotai Not a pure module */
